import RouteProtection from "../common/RouteProtection";
import Header from "../common/Header";
import PageContainer from "../common/PageContainer";
import Calendar from "./Calendar/Calendar";
import ReservationList from "./ReservationList/ReservationList";
import Tab from "../common/Tab/Tab";
import TabPage from "../common/Tab/TabPage";

import { useEffect, useState } from "react";
import uniqid from "uniqid";
import { fetchWithToken } from "../../functions/fetch";
import { sortReservation } from "../../functions/reservation";

const ReservationPage = () => {
  const [futureReservationList, setFutureReservationList] = useState([]);
  const [overdueReservationList, setOverdueReservationList] = useState([]);
  const [timeSlots, setTimeSlots] = useState([]);
  const [tabIndex, setTabIndex] = useState(0);
  const [refetchReservation, setRefetchReservation] = useState(true);

  const tabs = [
    <Calendar
      reservations={futureReservationList}
      timeSlots={timeSlots}
      setRefetchReservation={setRefetchReservation}
      key={uniqid()}
    />,
    <ReservationList
      key={uniqid()}
      reservations={futureReservationList}
      setFunction={setFutureReservationList}
      canDelete
      isOverdue={false}
      timeSlots={timeSlots}
      setTimeSlots={setTimeSlots}
      setRefetchReservation={setRefetchReservation}
    />,
    <ReservationList
      key={uniqid()}
      reservations={overdueReservationList}
      setFunction={setOverdueReservationList}
      canDelete={false}
      isOverdue
      timeSlots={timeSlots}
      setTimeSlots={setTimeSlots}
      setRefetchReservation={setRefetchReservation}
    />,
  ];
  const tabText = ["行事曆", "預約清單", "過期預約"];

  useEffect(() => {
    if (!refetchReservation) {
      return;
    }

    const midnight = new Date();
    midnight.setHours(0, 0, 0, 0);
    const nowStr = midnight.toISOString();

    Promise.all([
      // get reservations after today
      fetchWithToken(
        "GET",
        `${process.env.REACT_APP_BACKEND_HOST}/api/reservation?startTime=${nowStr}`,
      ),
      // get overdue reservations
      fetchWithToken(
        "GET",
        `${process.env.REACT_APP_BACKEND_HOST}/api/reservation?endTime=${nowStr}`,
      ),
      // fetch timeSlots
      fetchWithToken(
        "GET",
        `${process.env.REACT_APP_BACKEND_HOST}/api/time-slot`,
      ),
    ])
      .then((responses) => {
        const [futureRes, overdueRes, timeSlotsRes] = responses;
        if (futureRes.status === 200) {
          setFutureReservationList(sortReservation(futureRes.data));
        } else {
          console.error(futureRes);
        }
        if (overdueRes.status === 200) {
          setOverdueReservationList(
            sortReservation(overdueRes.data, "DESCEND"),
          );
        } else {
          console.error(overdueRes);
        }
        if (timeSlotsRes.status === 200) {
          setTimeSlots(timeSlotsRes.data);
        } else {
          console.error(timeSlotsRes);
        }
      })
      .catch((error) => {
        console.error(error);
      });

    setRefetchReservation(false);
  }, [refetchReservation]);

  return (
    <>
      <RouteProtection />
      <Header />
      <PageContainer>
        <Tab texts={tabText} tabIndex={tabIndex} setTabIndex={setTabIndex} />
        <TabPage pages={tabs} tabIndex={tabIndex} />
      </PageContainer>
    </>
  );
};

export default ReservationPage;
